export default __webpack_public_path__ + "static/media/avatar03.b20b1d29.svg";